<template>
  <div>
    <el-dialog
      title="提交审核"
      :visible.sync="show"
      class="examine-dialog"
      :before-close="handleClose">
      <div class="card">

        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label>渠道</label>
              <div>
                <el-select v-model="params.channelIds" multiple placeholder="输入搜索">
                  <el-option
                    v-for="item in configs.channel_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="configs.needSelectAuditLine">
          <div class="col-md-12">
            <div class="mb-3">
              <label>审核线</label>
              <div>
                <el-select v-model="params.auditLineId" @change="changeAuditLine" filterable placeholder="输入搜索">
                  <el-option
                    v-for="item in configs.auditLine"
                    :key="item.auditLineId"
                    :label="item.auditLineName"
                    :value="item.auditLineId">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label>下一道审核人</label>
              <div>
                <el-select v-model="params.checkerId" filterable placeholder="输入搜索">
                  <el-option
                    v-for="item in checkerConfig"
                    :key="item.id"
                    :label="item.real_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label>分类</label>
              <div>
                <el-select v-model="params.classifyId" filterable placeholder="输入搜索">
                  <el-option
                    v-for="item in configs.levs"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>

        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button @click="handleClose()" class="btn-sm btn btn-outline-dark" type="button">取消</button>
              <button @click="submitCreate()" class="btn-sm btn btn-primary" type="button">确定</button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import Vue from "vue";
import Swal from "sweetalert2";
import content from '../../../server/api/videoPublish'


export default {
  components: {},

  data() {
    return {
      currentItem: {},
      params: {
        "accountId": "",
        "channelIds": "", //渠道
        "checkerId": "", //下一道审核人
        "classifyId": "", //分类
        "mediaId": "",
        "auditLineId": "" //审核线
      },
      configs: [],
      items: [],
      show: false,
      isBatchArr: false,
      checkerConfig: [],
    };
  },

  props: {},

  mounted() {},

  methods: {
    showModel(item, arr){
      this.params = {
        "accountId": "",
        "channelIds": "",
        "checkerId": "",
        "classifyId": "",
        "mediaId": "",
        "auditLineId": ""
      }
      if(arr){ //是否是批量
        this.isBatchArr = true
      } else {
        this.isBatchArr = false
      }
      this.currentItem = item
      this.getBaseConf()
      this.show = true
    },

    handleClose(){
      this.show = false
      let obj = {
        code: 'handleExamine'
      }
      this.$emit('pageCallback', obj)
    },

    changeAuditLine(indexId){
      let currentAudit = {}
      for (var i = 0; i < this.configs.auditLine.length; i++) {
        if(indexId === this.configs.auditLine[i].auditLineId){
          currentAudit = this.configs.auditLine[i]
        }
      }
      this.checkerConfig = currentAudit.next_checker_config
      this.params.checkerId = ""
    },

    //获取列表数据
    getBaseConf() {
      let adminUser = JSON.parse(this.cookies.getCookie('user'));
      let params = {
        id: adminUser.adminId
      }
      content.baseConf(params).then(resp => {
        if (resp.data) {
          // 审核线是否启用
          if(resp.data.needSelectAuditLine){
            this.checkerConfig = []
          } else {
            this.checkerConfig = resp.data.next_checker_config
          }
          this.configs = resp.data
          // 获取到审核数据后查找有没有上一次审核的缓存
          let storageExamineParams = sessionStorage.getItem('examineParams');
          if(storageExamineParams){
            let stgeParams = JSON.parse(storageExamineParams)
            this.params.channelIds = stgeParams.channelIds
            this.params.checkerId = stgeParams.checkerId
            this.params.classifyId = stgeParams.classifyId
            this.params.auditLineId = stgeParams.auditLineId
          }
        }
      })
    },

    submitCreate(){
      let params = this.params
      let adminUser = JSON.parse(this.cookies.getCookie('user'));
      params.accountId = adminUser.adminId
      if(!params.channelIds){
        Vue.swal("请选择渠道");
        return
      }
      // 审核线启用判断是否选择了审核线
      if(this.configs.needSelectAuditLine){
        if(!params.auditLineId){
          Vue.swal("请选择审核线");
          return
        }
      }
      if(!params.checkerId){
        Vue.swal("请选择下一道审核人");
        return
      }
      if(!params.classifyId){
        Vue.swal("请选择分类");
        return
      }
      if(this.isBatchArr){ //true为批量
        this.httpArr = 0 // 记录请求返回的次数，最后应该和currentItem.length一致
        for (var i = 0; i < this.currentItem.length; i++) {
          let item = this.currentItem[i]
          params.mediaId = this.currentItem[i].id
          this.addExamineStorage(params)
          this.submitExamine(params)
        }
      } else {
        params.mediaId = this.currentItem.id
        this.addExamineStorage(params)
        this.submitExamine(params)
      }
    },

    submitExamine(params){
      content.longyuanExamine(params).then(resp => {
        if (resp.code == 0) {
          if(this.isBatchArr){//true为批量
            this.httpArr = this.httpArr + 1
            if(this.httpArr == this.currentItem.length){ //已全部请求完毕
              Vue.swal({
                icon: "success",
                title: "提交成功！",
                showConfirmButton: false,
                timer: 1000
              });
              let obj = {
                code: 'examine'
              }
              this.$emit('pageCallback', obj)
              this.handleClose()
            }
          } else {
            Vue.swal({
              icon: "success",
              title: "提交成功！",
              showConfirmButton: false,
              timer: 1000
            });
            let obj = {
              code: 'examine'
            }
            this.$emit('pageCallback', obj)
            this.handleClose()
          }
        } else {
          Vue.swal(resp.msg);
        }
      })
    },

    addExamineStorage(params){
      let examineParams = {
        "channelIds": params.channelIds, //渠道
        "checkerId": params.checkerId, //下一道审核人
        "classifyId": params.classifyId, //分类
        "auditLineId": params.auditLineId, //审核线
      }
      sessionStorage.setItem('examineParams', JSON.stringify(examineParams));
    }

  }

};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

  .examine-dialog .card{
    margin-bottom: 0px;
  }

  .examine-dialog .el-select{
    display: block;
  }

  .examine-dialog .el-dialog{
    width: 465px;
    border-radius: 6px;
    margin-top: 0 !important;
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    max-height: 90vh;
  }

</style>

